import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TimeConverter {

  getTimeInputConvertedToSeconds(input: string): number {
    if (input?.length === 0) { return 0; }

    let hours = 0, minutes = 0;

    try {
      const parsedHours = parseInt(input.substring(0, 2), 10);
      hours = parsedHours;

      if (input.length >= 4) {
        const parsedMinutes = parseInt(input.substring(2, 4), 10);
        minutes = parsedMinutes;
      }
    } catch (err) {
      console.log(`TimeConverter.getTimeInputConvertedToSeconds: Failed to parse time input: ${input}`);
    }

    return (hours * 3600) + (minutes * 60);
  }

  getTimeInputConvertedToHoursAndMinutes(input: string): string {
    input = input.replace(":", "");
    if (input?.length !== 4) { return "00:00"; }
    return `${input.substring(0, 2)}:${input.substring(2, 4)}`;
  }

  getTimeInputAsHoursAndMinutesConvertedToSeconds(hours: any, minutes: any): number {
    if (!hours) { hours = 0; }
    if (!minutes) { minutes = 0; }

    return (hours * 3600) + (Number(minutes) * 60);
  }
}
